import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {FormGroup} from "@unibuddy/patron";
import * as yup from "yup";

import useAuth from "shared/Auth/hooks/useAuth";

import ReactSelect from "../../../../../shared/Experimental/Forms/components/ReactSelect/ReactSelect";
import {CountryField, Maybe} from "../../../../../types/generated";
import {IntlNamespaces} from "../../../../../translations/types";
import {
    INTL_NO_OPTIONS_MESSAGE,
    INTL_SELECT_COUNTRY,
    INTL_WHERE_DO_YOU_LIVE,
} from "../../../../../translations/signup";
import {INTL_COUNTRY_REQUIRED} from "../../../../../translations/validations";

export function CountryFormField({allCountries}: {allCountries: Array<Maybe<CountryField>>}) {
    const {t} = useTranslation([IntlNamespaces.VALIDATIONS, IntlNamespaces.SIGNUP, "countries"]);
    const {authState} = useAuth();
    const userHasCountry = authState?.me?.anyUser?.country ?? false;

    const countries = allCountries.filter((country) => !!country);

    if (userHasCountry || countries.length === 0) return null;

    return (
        <FormGroup
            initialValue={null}
            validation={yup
                .object()
                .nullable()
                .required(
                    t(
                        `${IntlNamespaces.VALIDATIONS}:${INTL_COUNTRY_REQUIRED.key}`,
                        INTL_COUNTRY_REQUIRED.defaultValue,
                    ),
                )}
            id="country"
            label={t(
                `${IntlNamespaces.SIGNUP}:${INTL_WHERE_DO_YOU_LIVE.key}`,
                INTL_WHERE_DO_YOU_LIVE.defaultValue,
            )}
        >
            <ReactSelect
                id="country"
                name="countrySelection"
                required
                placeholder={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_COUNTRY.key}`,
                    INTL_SELECT_COUNTRY.defaultValue,
                )}
                aria-label={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_COUNTRY.key}`,
                    INTL_SELECT_COUNTRY.defaultValue,
                )}
                filterLabel={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_COUNTRY.key}`,
                    INTL_SELECT_COUNTRY.defaultValue,
                )}
                noOptionsMessage={() =>
                    t(
                        `${IntlNamespaces.SIGNUP}:${INTL_NO_OPTIONS_MESSAGE.key}`,
                        INTL_NO_OPTIONS_MESSAGE.defaultValue,
                    )
                }
                options={countries.map(({id, name}) => ({
                    value: id,
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-argument
                    label: t(`${name}`, name, {
                        ns: "countries",
                    }),
                }))}
            />
        </FormGroup>
    );
}
